module.exports = "/images/favicon.ico?1f24fc1";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/favicon.ico
// module id = 19
// module chunks = 0